import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { finalize } from "rxjs/operators";
import { CommentService } from "../models/comment.service";
import { ProjectService } from "../models/project.service";
import { SetFocusService } from "../set-focus/set-focus.service";

@Component({
  selector: "ab-comment-list",
  templateUrl: "./comment-list.component.html",
})
export class CommentListComponent implements OnInit {
  @Input() public group: any;
  @Input() public user: any;
  public comment: any;
  public commenting: boolean;
  public comments: any[];
  public loading: boolean;
  public memberCount: any;
  public nativeEl: any;
  public newCommentAttrs: any;
  public textarea: any;

  constructor(
    private commentService: CommentService,
    private elem: ElementRef,
    private projectService: ProjectService,
    private setFocusService: SetFocusService,
  ) {
    this.nativeEl = this.elem.nativeElement;
  }

  public trackById(_index: number, comment: any) {
    return comment.id;
  }

  public create() {
    this.commenting = true;
    this.commentService
      .create(this.comment)
      .pipe(
        finalize(() => {
          delete this.commenting;
        }),
      )
      .subscribe(() => {
        this.group.commentCount += 1;
        this.comments.push(this.comment);
        this.comment = this.commentService.new(this.newCommentAttrs);
      });
  }

  public destroy(comment: any) {
    if (!confirm("Are you sure you want to delete this comment?")) {
      return;
    }

    this.commentService.destroy(comment).subscribe(() => {
      this.group.commentCount -= 1;
      this.comments.splice(this.comments.indexOf(comment), 1);
    });
  }

  public ngOnInit() {
    this.comments = [];
    this.newCommentAttrs = {
      user: this.user,
      groupId: this.group.id,
      projectId: this.group.projectId,
    };
    this.comment = this.commentService.new(this.newCommentAttrs);
    this.fetchComments();

    this.projectService
      .get({ projectId: this.group.projectId })
      .subscribe((data: any) => (this.memberCount = data.memberCount));

    this.textarea = this.nativeEl.querySelector("textarea");
    this.textarea.addEventListener("keydown", (event: KeyboardEvent) => {
      if (this.commenting || !this.comment.comment) {
        return;
      }
      // Allow submitting form with CMD/CTRL + ENTER
      if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
        this.create();
      }
    });
  }

  private fetchComments() {
    this.loading = true;
    this.commentService
      .query({ projectId: this.group.projectId, groupId: this.group.id })
      .pipe(
        finalize(() => {
          this.loading = false;
          this.setFocusService.for("commentList:textarea");
        }),
      )
      .subscribe((data: any) => (this.comments = data));
  }
}
